import React from 'react';
import CollectibleCoinViewer from './CollectibleCoinViewer';
import styles from './CollectiblePreviewSurface.module.css';

export default function CollectiblePreviewSurface({
  hasPlayableVideo = false,
  mediaUrl = '',
  playbackUrl = '',
  posterUrl = '',
  backTextureUrl = '',
  title = 'Collectible',
  placeholderLabel = 'Collectible',
  onPlaybackError = null,
  paneClassName = '',
  stageClassName = '',
  viewerClassName = '',
  placeholderClassName = '',
}) {
  return (
    <div className={`${styles.pane} ${hasPlayableVideo ? styles.paneVideo : ''} ${paneClassName}`.trim()}>
      <div className={`${styles.stage} ${stageClassName}`.trim()}>
        {hasPlayableVideo ? (
          <div className={styles.coinShell}>
            <CollectibleCoinViewer
              className={`${styles.coinViewer} ${viewerClassName}`.trim()}
              playbackUrl={playbackUrl}
              posterUrl={posterUrl || mediaUrl}
              backTextureUrl={backTextureUrl}
              title={title}
              onPlaybackError={onPlaybackError}
            />
          </div>
        ) : mediaUrl ? (
          <img src={mediaUrl} alt={title} className={styles.image} />
        ) : (
          <div className={`${styles.placeholder} ${placeholderClassName}`.trim()}>{placeholderLabel}</div>
        )}
      </div>
    </div>
  );
}
